export default __webpack_public_path__ + "static/media/ImageSelect_comp.4b001cbc.png";